import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=266135cf&"
var script = {}
import style0 from "./Loader.vue?vue&type=style&index=0&id=266135cf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports